<template>
    <el-dialog
        v-model="visible"
        title="宠物详情"
        width="920px"
        top="6vh"
        append-to-body
        :close-on-click-modal="false"
        @closed="handleClosed"
    >
        <el-tabs v-model="activeTab" class="setting-new-tabs">
            <el-tab-pane
                v-for="item in tabsdata"
                :key="item.value"
                :label="item.label"
                :name="item.value"
            />
        </el-tabs>

        <div class="pet-detail-dialog" v-loading="loading">
            <div v-if="activeTab == 1" class="tab-pane-box">
                <div class="pet-profile">
                    <div class="pet-profile-cover">
                        <wcimage :value="info.thumb" :option="{size:'large',showBig:true}" />
                    </div>
                    <div class="pet-profile-main">
                        <div class="pet-profile-name">
                            <span v-if="info.breedname">【{{ info.breedname }}】</span>{{ displayText(info.name) }}
                        </div>
                        <div class="pet-profile-meta">
                            {{ displayText(info.pettype) }} · {{ displayText(info.sexname) }} · {{ ageText }}
                        </div>
                        <div class="pet-profile-tags">
                            <span class="pet-tag" v-if="info.salestatusname">{{ info.salestatusname }}</span>
                            <span class="pet-tag" v-if="info.issterilizationname">{{ info.issterilizationname }}</span>
                            <span class="pet-tag" v-if="info.iszhongname">{{ info.iszhongname }}</span>
                        </div>
                    </div>
                </div>

                <div class="pet-album" v-if="info.photos && info.photos.length">
                    <wcimage
                        v-for="(photo, index) in info.photos"
                        :key="'ph-'+index"
                        :value="photo.thumb"
                        :option="{size:'middle',showBig:true}"
                    />
                </div>

                <div class="pet-section" v-for="section in infoSections" :key="section.title">
                    <div class="pet-section-title">{{ section.title }}</div>
                    <div class="pet-info-grid">
                        <div class="pet-info-item" v-for="item in section.items" :key="item.label">
                            <div class="pet-info-label">{{ item.label }}</div>
                            <div class="pet-info-value">{{ item.value }}</div>
                        </div>
                    </div>
                </div>
            </div>

            <div v-if="activeTab == 2" class="tab-pane-box">
                <div class="TTL-table">
                    <el-table :data="record.list" stripe="true" empty-text="">
                        <template v-slot:empty><el-empty description="暂无记录" /></template>
                        <el-table-column label="记录类型" prop="typename" align="center" />
                        <el-table-column label="记录内容" prop="content" align="center" show-overflow-tooltip />
                        <el-table-column label="记录时间" prop="recordtime" align="center" />
                        <el-table-column label="添加时间" prop="inputtime" align="center" />
                    </el-table>
                </div>
                <div class="TTL-page-box top20">
                    <div class="TTL-page-box-in">
                        <div class="TTL-page TTL-page-right">
                            <wcpage
                                :row="record.rows"
                                :p="record.p"
                                :rollpage="record.rollpage"
                                @finish="(val)=> { record.p=val.p; record.rollpage=val.rollpage; GetRecordList(); }"
                            />
                        </div>
                    </div>
                </div>
            </div>

            <div v-if="activeTab == 3" class="tab-pane-box">
                <div class="TTL-table">
                    <el-table :data="schedule.list" stripe="true" empty-text="">
                        <template v-slot:empty><el-empty description="暂无日程提醒" /></template>
                        <el-table-column label="提醒类型" align="center">
                            <template #default="scope">
                                {{ scope.row.notice_typename || '-' }}
                            </template>
                        </el-table-column>
                        <el-table-column label="创建时间" align="center">
                            <template #default="scope">
                                {{ displayJoin(scope.row.create_day, scope.row.create_time) }}
                            </template>
                        </el-table-column>
                        <el-table-column label="提醒时间" align="center">
                            <template #default="scope">
                                {{ scope.row.isremind==1 ? displayJoin(scope.row.remind_day, scope.row.remind_time) : '/' }}
                            </template>
                        </el-table-column>
                        <el-table-column label="状态" align="center">
                            <template #default="scope">
                                {{ scope.row.status==0 ? '进行中' : '已完成' }}
                            </template>
                        </el-table-column>
                        <el-table-column label="备注" prop="note" align="center" show-overflow-tooltip />
                    </el-table>
                </div>
                <div class="TTL-page-box top20">
                    <div class="TTL-page-box-in">
                        <div class="TTL-page TTL-page-right">
                            <wcpage
                                :row="schedule.rows"
                                :p="schedule.p"
                                :rollpage="schedule.rollpage"
                                @finish="(val)=> { schedule.p=val.p; schedule.rollpage=val.rollpage; GetScheduleList(); }"
                            />
                        </div>
                    </div>
                </div>
            </div>

            <div v-if="activeTab == 4" class="tab-pane-box">
                <div class="TTL-table">
                    <el-table :data="birth.list" stripe="true" empty-text="">
                        <template v-slot:empty><el-empty description="暂无繁育信息" /></template>
                        <el-table-column label="繁育宠物" align="center">
                            <template #default="scope">
                                {{ (scope.row.boy_pet_name || '-') + ' x ' + (scope.row.girl_pet_name || '-') }}
                            </template>
                        </el-table-column>
                        <el-table-column label="交配时间" prop="loveday" align="center" />
                        <el-table-column label="预产期" align="center">
                            <template #default="scope">
                                <div>{{ scope.row.expireday || '-' }}</div>
                                <div class="birth-sub" v-if="scope.row.birthday || scope.row.lastday">（剩余 {{ scope.row.lastday !== undefined ? scope.row.lastday : scope.row.birthday }} 天）</div>
                            </template>
                        </el-table-column>
                        <el-table-column label="生产提醒" prop="expire_remind_day" align="center" />
                        <el-table-column label="状态" align="center">
                            <template #default="scope">
                                {{ scope.row.status==0 ? '进行中' : '已完成' }}
                            </template>
                        </el-table-column>
                    </el-table>
                </div>
                <div class="TTL-page-box top20">
                    <div class="TTL-page-box-in">
                        <div class="TTL-page TTL-page-right">
                            <wcpage
                                :row="birth.rows"
                                :p="birth.p"
                                :rollpage="birth.rollpage"
                                @finish="(val)=> { birth.p=val.p; birth.rollpage=val.rollpage; GetBirthList(); }"
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <template #footer>
            <div class="dialog-footer">
                <wcbutton :option="{title:'关闭',type:'del'}" @finish="visible=false" />
            </div>
        </template>
    </el-dialog>
</template>

<script>
import INTERFACE_MODEL_PETS from '@/Interface/Pets/Pets';

export default {
    name: 'PetDetailDialog',
    props: {
        modelValue: {
            type: Boolean,
            default: false,
        },
        petId: {
            type: [Number, String],
            default: '',
        },
    },
    emits: ['update:modelValue'],
    data() {
        return {
            loading: false,
            activeTab: 1,
            tabsdata: [
                { label: '宠物信息', value: 1 },
                { label: '宠物记录', value: 2 },
                { label: '日程提醒', value: 3 },
                { label: '繁育信息', value: 4 },
            ],
            info: {},
            record: { list: [], p: 1, rollpage: 10, rows: 0, loaded: false },
            schedule: { list: [], p: 1, rollpage: 10, rows: 0, loaded: false },
            birth: { list: [], p: 1, rollpage: 10, rows: 0, loaded: false },
        };
    },
    computed: {
        visible: {
            get() {
                return this.modelValue;
            },
            set(val) {
                this.$emit('update:modelValue', val);
            },
        },
        infoSections() {
            return [
                {
                    title: '基础信息',
                    items: [
                        { label: '所属类型', value: this.displayText(this.info.pettype) },
                        { label: '品种', value: this.displayText(this.info.breedname) },
                        { label: '性别', value: this.displayText(this.info.sexname) },
                        { label: '年纪', value: this.ageText },
                        { label: '生日', value: this.displayText(this.info.birthday) },
                        { label: '添加时间', value: this.displayText(this.info.inputtime) },
                    ],
                },
                {
                    title: '体征信息',
                    items: [
                        { label: '身高', value: this.info.height ? this.info.height + ' cm' : '-' },
                        { label: '体重', value: this.info.weight ? this.info.weight + ' kg' : '-' },
                        { label: '被毛类型', value: this.displayText(this.info.hairtypename) },
                        { label: '血型', value: this.displayText(this.info.bloodtypename) },
                    ],
                },
                {
                    title: '健康与销售',
                    items: [
                        { label: '是否绝育', value: this.displayText(this.info.issterilizationname) },
                        { label: '是否种公/母', value: this.displayText(this.info.iszhongname) },
                        { label: '销售状态', value: this.displayText(this.info.salestatusname) },
                        { label: '疫苗信息', value: this.displayText(this.info.vaccinesname) },
                        { label: '驱虫情况', value: this.displayText(this.info.DownMingname) },
                    ],
                },
            ];
        },
        ageText() {
            if (this.info.age === '' || this.info.age === null || this.info.age === undefined) return '-';
            return this.info.age > 0 ? this.info.age + '岁' : '小于1岁';
        },
    },
    watch: {
        modelValue(val) {
            if (val && this.petId) this.ResetAndLoad();
        },
        petId(val) {
            if (this.modelValue && val) this.ResetAndLoad();
        },
        activeTab() {
            if (this.visible) this.LoadCurrentTab();
        },
    },
    methods: {
        displayText(val) {
            return val === '' || val === null || val === undefined ? '-' : val;
        },
        displayJoin(a, b) {
            const left = a ? a : '';
            const right = b ? b : '';
            const text = (left + ' ' + right).trim();
            return text || '-';
        },
        ResetAndLoad() {
            const stayFirst = this.activeTab == 1;
            this.info = {};
            this.record = { list: [], p: 1, rollpage: 10, rows: 0, loaded: false };
            this.schedule = { list: [], p: 1, rollpage: 10, rows: 0, loaded: false };
            this.birth = { list: [], p: 1, rollpage: 10, rows: 0, loaded: false };
            this.activeTab = 1;
            if (stayFirst) this.LoadCurrentTab();
        },
        LoadCurrentTab() {
            if (this.activeTab == 1) this.GetDetail();
            if (this.activeTab == 2) this.GetRecordList();
            if (this.activeTab == 3) this.GetScheduleList();
            if (this.activeTab == 4) this.GetBirthList();
        },
        GetDetail() {
            if (!this.petId) return;
            this.loading = true;
            INTERFACE_MODEL_PETS.GET_PET_DETAIL_INFO({ id: this.petId }).then((res) => {
                this.loading = false;
                if (res.status > 0) return false;
                this.info = res.data || {};
            });
        },
        GetRecordList() {
            if (!this.petId) return;
            this.loading = true;
            INTERFACE_MODEL_PETS.GET_PET_RECORD_LIST({
                petid: this.petId,
                p: this.record.p,
                rollpage: this.record.rollpage,
            }).then((res) => {
                this.loading = false;
                if (res.status > 0) return false;
                this.record.rows = res.data.count || 0;
                this.record.list = res.data.list || [];
                this.record.loaded = true;
            });
        },
        GetScheduleList() {
            if (!this.petId) return;
            this.loading = true;
            INTERFACE_MODEL_PETS.GET_PET_SCHEDULE_LIST({
                petid: this.petId,
                p: this.schedule.p,
                rollpage: this.schedule.rollpage,
            }).then((res) => {
                this.loading = false;
                if (res.status > 0) return false;
                this.schedule.rows = res.data.count || 0;
                this.schedule.list = res.data.list || [];
                this.schedule.loaded = true;
            });
        },
        GetBirthList() {
            if (!this.petId) return;
            this.loading = true;
            INTERFACE_MODEL_PETS.GET_PET_BIRTH_LIST({
                petid: this.petId,
                p: this.birth.p,
                rollpage: this.birth.rollpage,
            }).then((res) => {
                this.loading = false;
                if (res.status > 0) return false;
                this.birth.rows = res.data.count || 0;
                this.birth.list = res.data.list || [];
                this.birth.loaded = true;
            });
        },
        handleClosed() {
            this.info = {};
            this.loading = false;
            this.activeTab = 1;
        },
    },
};
</script>
<style scoped>
.pet-detail-dialog {
    min-height: 280px;
    max-height: 62vh;
    overflow-y: auto;
    padding: 0 6px;
}
.tab-pane-box {
    min-height: 200px;
}
.pet-profile {
    display: flex;
    align-items: center;
    padding: 16px 18px;
    background: #FAFAFA;
    border: 1px solid #F2F6FC;
    border-radius: 12px;
}
.pet-profile-cover :deep(.large) {
    width: 120px;
    height: 120px;
    border-radius: 16px;
}
.pet-profile-main {
    margin-left: 20px;
    min-width: 0;
}
.pet-profile-name {
    font-size: 16px;
    font-weight: 600;
    color: #333;
    letter-spacing: 1px;
    word-break: break-all;
}
.pet-profile-meta {
    margin-top: 8px;
    font-size: 13px;
    color: #999;
    letter-spacing: 1px;
}
.pet-profile-tags {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
    margin-top: 12px;
}
.pet-tag {
    display: inline-block;
    padding: 4px 10px;
    border-radius: 20px;
    background: rgba(102, 110, 235, 0.1);
    color: #666eeb;
    font-size: 12px;
    letter-spacing: 1px;
}
.pet-album {
    display: flex;
    flex-wrap: wrap;
    gap: 10px;
    margin-top: 16px;
}
.pet-section {
    margin-top: 20px;
}
.pet-section-title {
    font-size: 15px;
    font-weight: 550;
    letter-spacing: 1px;
    color: #666;
    padding: 4px 0 12px;
}
.pet-info-grid {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    border-top: 1px solid #F2F6FC;
    border-left: 1px solid #F2F6FC;
}
.pet-info-item {
    padding: 14px 16px;
    border-right: 1px solid #F2F6FC;
    border-bottom: 1px solid #F2F6FC;
    background: #fff;
}
.pet-info-label {
    font-size: 12px;
    color: #999;
    letter-spacing: 1px;
    margin-bottom: 6px;
}
.pet-info-value {
    font-size: 13px;
    color: #333;
    letter-spacing: 1px;
    word-break: break-all;
}
.birth-sub {
    color: #999;
    font-size: 12px;
    margin-top: 4px;
}
.dialog-footer {
    display: flex;
    justify-content: flex-end;
}
.setting-new-tabs :deep(.el-tabs__header) {
    margin-bottom: 16px;
}
.setting-new-tabs :deep(.el-tabs__item) {
    font-size: 13px;
    letter-spacing: 1px;
    color: #999;
    font-weight: normal;
}
.setting-new-tabs :deep(.el-tabs__item.is-active) {
    color: #666eeb;
    font-weight: 600;
}
.setting-new-tabs :deep(.el-tabs__active-bar) {
    background-color: #666eeb;
}
.setting-new-tabs :deep(.el-tabs__nav-wrap::after) {
    height: 1px;
    background-color: #F2F6FC;
}
</style>
